/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cool_Pale_Otter_WadeInputs */

const en_cool_pale_otter_wade = /** @type {(inputs: Cool_Pale_Otter_WadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controls how strictly participant anonymity is enforced when generating results.`)
};

const de_cool_pale_otter_wade = /** @type {(inputs: Cool_Pale_Otter_WadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Steuert, wie strikt die Anonymität der Teilnehmer bei der Ergebniserstellung gewahrt wird.`)
};

/**
* | output |
* | --- |
* | "Controls how strictly participant anonymity is enforced when generating results." |
*
* @param {Cool_Pale_Otter_WadeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cool_pale_otter_wade = /** @type {((inputs?: Cool_Pale_Otter_WadeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cool_Pale_Otter_WadeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cool_pale_otter_wade(inputs)
	return de_cool_pale_otter_wade(inputs)
});